var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    staticClass: "nshop-order-view-pins",
    attrs: {
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref) {
          var value = _ref.value,
              item = _ref.item;
          return [_c('span', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    })], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    itemsPerPage: -1,
    itemClass: function itemClass(item) {
      return item.isGained ? 'is-gained--true' : 'is-gained--false';
    }
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }